import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import { Pagination, Input, Form, Select, Row, Col, DatePicker, message } from 'antd';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { EditTwoTone, BranchesOutlined, PrinterOutlined, LoadingOutlined } from '@ant-design/icons';
import getHeaders from '../../utils/authHeaders';
import ListinngCard from '../../layouts/ListingCard';
import { dateConverter } from '../../utils/utcDateConversionCommon';
import AddNewImg from '../../assets/images/add-new.png';
import lockIcon from '../../assets/images/lock.png';
import { SearchBar } from '../../layouts/SearchBar';
import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';
import LoaderImage from '../LoaderImage';
import NoDataFound from '../../layouts/NoDataFound';
import Barcode from 'react-barcode';
import { BarCodeDiv, SpacingDiv } from './BarCodePrinting';
// import QRCodeLogo from '../../lib/QRCodeLogo';
// import { BarCodeDiv } from '../genericBoxManagement/GenericBoxManagement';
const handleClose = () => setShow(false);
const BarCodeFields = () => {
   return (
     <div>
       <p style={{ fontSize: '0.5rem', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>Full Name: _________________ </p>
       <p style={{ fontSize: '0.5rem', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>Col. Date: _________________</p>
       <p style={{ fontSize: '0.5rem', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>DOB: _________________</p>
     </div>
   );
};
 




const oldBarCodeDiv = ({ value }) => {
  return (
    // <div className='w-50 d-flex flex-column align-items-center justify-content-center'>
    // <div className={`w-${md || 50} d-flex flex-column align-items-center justify-content-center`}>
    //  <div className={`w-100 d-flex flex-column align-items-center justify-content-center`}>
    //    <Barcode width={1} format='CODE128' fontSize={10} height={20} value={value} />
    //    <BarCodeFields />
    //  </div>
    //  <div
    //    style={{
    //      width: '4in',
    //      height: '1in',
    //      position: 'relative',
    //      fontFamily: 'Arial, sans-serif',
    //    }}
    //  >
    //    <div
    //      style={{
    //        //  width: '2in',
    //        //  height: '1in',
    //        //  position: 'absolute',
    //        top: 0,
    //        left: 0,
    //        display: 'flex',
    //        flexDirection: 'column',
    //        justifyContent: 'flex-start',
    //        alignItems: 'flex-start',
    //        //  padding: '0.05in',
    //        boxSizing: 'border-box',
    //      }}
    //    >
    //      <div style={{ width: '2in', overflow: 'hidden' }}>
    //        <Barcode
    //          value='KUS-LVB-G04-741706120'
    //          format='CODE128'
    //          width={0.8} // bar width reduced
    //          height={50} // adjust as needed
    //          fontSize={10}
    //          displayValue={true}
    //        />
    //      </div>

    //      <div style={{ fontSize: '5pt', lineHeight: '1.5' }}>
    //        <div>
    //          <strong>Full Name:</strong> __________________
    //        </div>
    //        <div>
    //          <strong>Col. Date:</strong> __________________
    //        </div>
    //        <div>
    //          <strong>DOB:</strong> ________________________
    //        </div>
    //        <div>
    //          {/* <p style={{ fontSize: '0.5rem', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>Full Name: _________________ </p>
    //   <p style={{ fontSize: '0.5rem', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>Col. Date:   _________________</p>
    //   <p style={{ fontSize: '0.5rem', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>DOB:          _________________</p> */}
    //        </div>
    //      </div>
    //    </div>
    //  </div>
    <div
      style={{
        width: '2in',
        height: '1in',
        position: 'relative',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      {/* Absolute-positioned inner container */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '2in',
          height: '1in',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        {/* Barcode */}
        <div style={{ width: '2in', margin: 0, padding: 0 }}>
          <Barcode value='B44li-yicur' format='CODE128' marginLeft={0} width={1} height={50} fontSize={10} displayValue={true} />
        </div>

        {/* Fields */}
        {/* <div style={{ fontSize: '5pt', lineHeight: '1.4', marginTop: '2px' }}>
          <div>
            <strong>Full Name:</strong> __________________
          </div>
          <div>
            <strong>Col. Date:</strong> __________________
          </div>
          <div>
            <strong>DOB:</strong> ________________________
          </div>
        </div> */}
      </div>
    </div>
  );
};
//  const SpacingDiv = () => {
//   return <div className='w-50 d-flex flex-column align-items-center justify-content-center'></div>;
// };

// const BarCodeDiv = ({ value, shortCode }) => {
//    return (
   
//      <div
//        style={{
//          width: '2in',
//          height: '1in',
//          position: 'relative',
//          fontFamily: 'Arial, sans-serif',
//        }}
//      >
//        {/* Absolute-positioned inner container */}
//        <div
//          style={{
//            position: 'absolute',
//            top: 0,
//            left: 0,
//            width: '2in',
//            height: '1in',
//            display: 'flex',
//            flexDirection: 'column',
//            justifyContent: 'flex-start',
//            alignItems: 'flex-start',
//            margin: 0,
//            padding: 0,
//            boxSizing: 'border-box',
//          }}
//        >
//          {/* Barcode */}
//          {/* <div> */}
//          {/* <div style={{ width: '2in', margin: 0, padding: 0 }}> */}
//          <Barcode value={shortCode} format='CODE128' marginLeft={0} width={1.3} height={50} fontSize={10} displayValue={false} />
//          {/* </div> */}
//          {/* <div> */}
//          <div style={{ marginTop: '-2px', margin: '0 auto' }}>
//            <p style={{ fontSize: '5pt', margin: '0 auto' }}>{value}</p>
//          </div>
//          {/* </div> */}
//          <div className=' ' style={{ margin: '0 auto' }}>
//            <p style={{ fontSize: '5pt', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>Full Name: _________________</p>
//            <p style={{ fontSize: '5pt', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>
//              Col. Date:<span style={{ visibility: 'hidden' }}>..</span>_________________
//            </p>
//            <p style={{ fontSize: '5pt', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>
//              DOB:<span style={{ visibility: 'hidden' }}>..........</span>_________________
//            </p>
//          </div>
        
//        </div>
//      </div>
//    );
//  };
// const SpacingDiv = () => <div style={{ width: '2in', height: '1in' }} />;

// const BarCodeDiv = ({ value, shortCode }) => (/
//   <div
//     style={{
//       width: '2in',
//       height: '1in',
//       position: 'relative',
//       fontFamily: 'Arial, sans-serif',
//     }}
//   >
//     <div
//       style={{
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '2in',
//         height: '1in',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'flex-start',
//         margin: 0,
//         padding: 0,
//         boxSizing: 'border-box',
//       }}
//     >
//       <Barcode value={shortCode} format='CODE128' marginLeft={0} width={1.3} height={45} fontSize={10} displayValue={false} />
//       <div style={{ marginTop: '-2px', margin: '0 auto', marginLeft: '80px' }}>
//         <p style={{ fontSize: '5pt', margin: '0 auto' }}>{value}</p>
//       </div>
//       <div style={{ margin: '0 auto', marginLeft: '50px' }}>
//         <p style={{ fontSize: '5pt', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>Full Name: __________________________</p>
//         <p style={{ fontSize: '5pt', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>
//           Col. Date:<span style={{ visibility: 'hidden' }}>...</span>__________________________
//         </p>
//         <p style={{ fontSize: '5pt', fontWeight: '700', color: 'black', whiteSpace: 'pre' }}>
//           DOB:<span style={{ visibility: 'hidden' }}>..........</span>__________________________
//         </p>
//       </div>
//     </div>
//   </div>
// );
// const BarCodeDiv = ({ value, shortCode }) => (
//   <div
//     style={{
//       width: '2in',
//       height: '1in',
//       position: 'relative',
//       fontFamily: 'Arial, sans-serif',
//       boxSizing: 'border-box',
//       padding: '0.05in',
//     }}
//   >
//     <div
//       style={{
//         width: '100%',
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'center',
//       }}
//     >
//       <Barcode value={shortCode} format='CODE128' width={1.4} height={40} margin={4} fontSize={10} displayValue={false} />
//       <p style={{ fontSize: '6pt', margin: '2px 0 4px', lineHeight: '1.2' }}>{value}</p>
//       <div
//         style={{
//           width: '100%',
//           paddingLeft: '0.1in', // consistent gap from left
//           fontSize: '5pt',
//           fontWeight: 700,
//           color: 'black',
//           lineHeight: '1.2',
//         }}
//       >
//         {['Full Name:', 'Col. Date:', 'DOB:'].map((label, i) => (
//           <div
//             key={i}
//             style={{
//               display: 'flex',
//               justifyContent: 'flex-start',
//               alignItems: 'baseline',
//               whiteSpace: 'nowrap',
//               marginBottom: '1px',
//             }}
//           >
//             <span style={{ minWidth: '0.6in', display: 'inline-block' }}>{label}</span>
//             {/* <span style={{ flexGrow: 1, borderBottom: '0.3pt solid black', height: '6pt' }} /> */}
//             <span
//               style={{
//                 width: '1in', // reduced line length
//                 borderBottom: '0.3pt solid black',
//                 height: '6pt',
//                 display: 'inline-block',
//               }}
//             />
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>
// );
const InventoryListing2 = () => {
  const [editbtn, setEditBtn] = useState('none');
  const [pageSize, setPageSize] = useState(10);
  const [fetchPartners, setFetchPartners] = useState([]);
  const [updbatchId, setUpdBatchId] = useState('');
  const [delBatchId, setDelBatchId] = useState('');
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState({});
  const [renderList, setRenderList] = useState([]);
  const [tableShow, setTableShow] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [err, setErr] = useState('');
  const [tableHeaders, setTableHeaders] = useState([]);
  const [show, setShow] = useState(false);
  const [lockModalShow, setLockModalShow] = useState(false);
  const [detailModalShow, setDetailModalShow] = useState(false);
  const [delBatchResp, setDelBatchResp] = useState({});
  const [lockBatchResp, setLockBatchResp] = useState({});
  const [inventoryListingResp, setInventoryListingResp] = useState([]);
  const [loader, setLoader] = useState(false);

 
  const handleLockClose = () => {
    setLockModalShow(false);
    setDetailModalShow(false);
  };
  let navigate = useNavigate();
  let convertedObj;

  const user = JSON.parse(localStorage.getItem('user'));
  if (user.userType === 'A') setEditBtn('block');
  const viewBatchDetails = (data) => {
    localStorage.setItem('batchId', JSON.stringify(data.batchId));
    console.log('Local Storage Set');
    navigate(`/inventory/batchreport`);
  };
  const addInventory = () => {
    navigate('/inventory/create', { replace: true });
  };

  const lockBatch = async () => {
    console.log('Consoling updated batch');
    console.log(updbatchId);
    const res = await axios.post(`${app.URL}/api/v1/admin/inventory/updatebatch`, { batchId: updbatchId }, { headers: getHeaders() });
    console.log(res);
    if (res && res.data.result.success) {
      console.log(res.data.result);
      setLockModalShow(false);
    }
  };
  const lockBatchFunc = (data) => {
    console.log(data);
    setLockModalShow(true);
    setUpdBatchId(data.batchId);
  };
  const deleteBatch = async (batchId) => {
    console.log('Consoling batch deleted');
    console.log(delBatchId);
    const res = await axios.delete(`${app.URL}/api/v1/admin/inventory/delete/${delBatchId}`, { headers: getHeaders() });
    console.log(res);
    if (res && res.data.result.success) {
      console.log(res.data.result);
      setLockBatchResp(res.data.result);
      setShow(false);
      // window.location.reload()
    }
  };
  const deleteBatchFunc = (data) => {
    console.log(data);
    setShow(true);
    setDelBatchId(data.batchId);
  };
  const inventoryListingApi = async (formData) => {
    console.log(formData);
    setLoader(true);

    const partnerResp = await axios.post(`${app.URL}/api/v1/admin/inventory/batchlisting`, formData, { headers: getHeaders() });
    console.log("partnerResp--->", partnerResp)
    partnerResp ? console.log(partnerResp.data.result.data) : '';
    partnerResp ? (convertedObj = dateConverter(partnerResp.data.result.data.data, 'issueDate')) : ' ';
    partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
    partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
    partnerResp.data.result ? setRenderList(convertedObj) : ' ';
    partnerResp.data.result && setLoader(false);
  };
  const onChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setPageSize(pageSize);
    setCurrentPage(page);
    if (!page) page = 1;
    let limit = pageSize;
    try {
      let reqObj;
      if (Object.keys(searchShow).length !== 0) {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: searchShow.searchBy,
          searchTxt: searchShow.searchTxt,
        };
      } else {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: 'firstName',
          searchTxt: '',
        };
      }
      console.log(reqObj);
      await inventoryListingApi(reqObj);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };

  // const getData = async () => {
  //   let formData = {
  //     limit: pageSize,
  //     offset: 0,
  //     searchBy: '',
  //     searchTxt: '',
  //   };
  //   console.log(formData);
  //   const partnerResp = await axios.post(`${app.URL}/api/v1/admin/inventory/batchlisting`, formData, { headers: getHeaders() });
  //   console.log(partnerResp);
  //   partnerResp ? console.log(partnerResp.data.result.data) : ' ';
  //   partnerResp.data.result ? (convertedObj = await dateConverter(partnerResp.data.result.data.data, 'issueDate')) : ' ';
  //   partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
  //   partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
  //   partnerResp.data.result ? setRenderList(convertedObj) : ' ';
  //   return console.log('return called');
  // };
  useEffect(() => {
    let formData = {
      limit: pageSize,
      offset: 0,
      searchBy: 'batchNo',
      searchTxt: '',
    };
    inventoryListingApi(formData);
  }, [lockModalShow, show]);

  let searchItems = [
    {
      name: 'Batch No.',
      value: 'batchNo',
    },
    {
      name: 'Product Name',
      value: 'product',
    },
  ];

  const onFinish = async (values) => {
    console.log(values);
    setSearchShow(values);
    let formData = {
      limit: 10,
      offset: 0,
      searchBy: values.searchBy,
      searchTxt: values.searchTxt,
    };
    if (!formData.searchTxt) message.error('Please enter search text');
    else await inventoryListingApi(formData);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const fetchInventoryByBatchId = async (invId) => {
    console.log(invId);
    setInventoryListingResp([]);
    const responseData = await axios.get(`${app.URL}/api/v1/admin/inventory/bybatch/${invId}`, { headers: getHeaders() });
    console.log(responseData);
    if (responseData.status === 200) {
      setInventoryListingResp(responseData.data.result.data);
    }
  };

  let printRef = useRef();

  const pageStyle = `
       @page {
        size: 4in 1in; /* Specify your custom page size here (width x height) */
          //  marginTop: 4px;
           margin: 0;
       }
      //   @page {
      //   size: 8.5in 11.5in; /* Specify your custom page size here (width x height) */
      //      marginTop: 4px;
      //      margin: 0;
      //  }
       body {
         font-family: Arial, sans-serif;
         margin: 0;
       }
       `;

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: pageStyle,
  });

  const [displayQRCode, setDisplayQRCode] = useState([]);

  const [printLoader, setPrintLoader] = useState(false);
  const [batchID, setBatchID] = useState('');

  const generateBarCode = (batch) => {
    let qrCodes = [];
    console.log(batch);

    // for (let i = 0; i < batch.length; i++) {
    //   for (let j = 0; j < batch[i].productSerials.length; j++) {
    //     let flag = batch[i].productSerials[j].serialNo.split('-')[2][0];
    //     console.log(' batch[i].productSerials[j]', batch[i].productSerials[j]);
    //     const count = batch[i].productSerials[j].verificationCount;
    //     console.log('count', count);
    //     const countArr = new Array(count == 1 ? Number(count)+1 : count == 2 ? 2 : count == 3 ? 3 : count == 4 ? 3 : 0).fill(count);
    //     console.log('CountArr', count % 2);
    //     console.log('flag', flag);
    //     // qrCodes.push(
    //     //   <QRCodeLogo value={batch[i].productSerials[j].serialNo} flag={flag} />
    //     // );
    //      qrCodes.push(
    //        <div
    //          key={`${i}-${j}`}
    //         //  style={{ display: 'flex' }}
    //          //style={{ pageBreakAfter: 'always' }} // 👈 Ensures each barcode starts on a new printed page
    //        >
    //         {countArr.map((_, indx) => {
    //             return (
    //               <div className='d-flex'>
    //               <BarCodeDiv value={batch[i].productSerials[j].serialNo} shortCode={batch[i].productSerials[j].shortCode} md={50} />
    //          {count % 2 === 0 ? <BarCodeDiv value={batch[i].productSerials[j].serialNo} shortCode={batch[i].productSerials[j].shortCode} /> : <SpacingDiv />}
    //               </div>
    //             );
    //           })}
             
    //        </div>
    //      );
    //   }
    // }
    for (let i = 0; i < batch.length; i++) {
      for (let j = 0; j < batch[i].productSerials.length; j++) {
        const serial = batch[i].productSerials[j];
        const printCount = serial.verificationCount;
        const flag = serial.serialNo.split('-')[2]?.[0];
        // const count = serial.verificationCount;
        // console.log("count",count)
        // const printCount = count === 1 ? 2 : count === 2 ? 3 : count === 3 ? 4 : count === 4 ? 5 : 0;
        // const printCount = serial.verificationCount;
0        // const printCount=1
        // Fill with actual data to render (not just number placeholders)
        const repeated = new Array(printCount).fill({
          value: serial.serialNo,
          shortCode: serial.shortCode,
        });

        // Chunk into rows of 2
        for (let k = 0; k < repeated.length; k += 2) {
          qrCodes.push(
            <div className='d-flex' key={`${i}-${j}-${k}`}>
              <BarCodeDiv value={repeated[k].value} shortCode={repeated[k].shortCode} />
              {repeated[k + 1] ? <BarCodeDiv value={repeated[k + 1].value} shortCode={repeated[k + 1].shortCode} /> : <SpacingDiv />}
            </div>
          );
        }
      }
    }
    setDisplayQRCode(qrCodes);

    setTimeout(() => {
      setPrintLoader(false);
      handlePrint();
      setBatchID('');
    }, 2000);
  };

  const handleRePrint = async (batchId) => {
    setBatchID(batchId);
    setPrintLoader(true);
    let formData = {
      batchId: batchId,
      // limit: qty,
      limit: "",
      offset: 0,
      searchBy: '',
      searchTxt: '',
    };
    const batchResp = await axios.post(`${app.URL}/api/v1/admin/inventory/batchreport`, formData, { headers: getHeaders() });
    batchResp ? console.log(batchResp.data.result.data.listing) : '';
    batchResp && generateBarCode(batchResp.data.result.data.listing);
  };

  const handleOnChange = async (e) => {
    if (e.target.value.length === 0) {
      let formData = {
        limit: pageSize,
        offset: 0,
        searchBy: '',
        searchTxt: '',
      };
      setSearchShow({});
      await inventoryListingApi(formData);
    }
  };

  console.log(renderList);

  return (
    <div className='dashboard-card container-fluid'>
      <div className='row p-0 pb-4'>
        <div className='for-before col-12 col-md-7 head fs-3 fw-bold' style={{ backgroundColor: '#a7c1d9', borderBottomRightRadius: '10px', color: '#FFFFFF' }}>
          Product Inventory
        </div>

        <div className='col-12 col-md-5 d-flex justify-content-center'>
          <div onClick={addInventory} className='icon-btn'>
            <img src={AddNewImg} />
            <p>Add Inventory</p>
          </div>
        </div>
      </div>

      <SearchBar onFinish={onFinish} onFinishFailed={onFinishFailed} searchItems={searchItems} onChange={handleOnChange} />
      <div style={{ display: 'none' }}>
        <div ref={printRef}>{displayQRCode.map((item) => item)}</div>
      </div>

      <div
        className='row table-scrollbar mr-0'
        style={{
          overflowX: 'auto',
        }}
      >
        {loader && <LoaderImage />}
        {renderList.length > 0 && !loader ? (
          <table id='customers'>
            <thead>
              <tr>
                <th>Batch No.</th>
                <th>Inventory Date</th>
                <th>Product</th>
                <th>Quantity</th>
                {/* <th>Partner</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {renderList.map((tableValues) => (
                <tr>
                  <td
                  // onClick={() => {
                  //   setDetailModalShow(true);
                  //   fetchInventoryByBatchId(tableValues.batchId);
                  // }}
                  // className='batchlink'
                  >
                    {tableValues.batchId ? tableValues.batchId : 'null'}
                  </td>
                  <td>{tableValues.issueDate ? tableValues.issueDate : 'null'}</td>
                  <td>{tableValues.ProductName ? tableValues.ProductName : 'null'}</td>
                  <td>{tableValues.availableQty ? tableValues.availableQty : 'null'}</td>
                  {/* <td>{tableValues.partnerName ? tableValues.partnerName : 'null'}</td> */}
                  {/* <td><button onClick={()=>viewBatchDetails(tableValues)}>ClickHere</button></td> */}
                  <td>
                    <button className='btn text-light mx-2' onClick={() => viewBatchDetails(tableValues)}>
                      View{' '}
                    </button>
                    <button
                      // disabled={batchID === tableValues.batchId}
                    disabled={true}  
                      
                      className='btn mx-2' onClick={() => handleRePrint(tableValues.batchId)}>
                      {printLoader && batchID === tableValues.batchId ? (
                        <LoadingOutlined
                          style={{
                            fontSize: '1.5rem',
                            color: 'white',
                          }}
                        />
                      ) : (
                          <PrinterOutlined
                        
                          style={{
                            fontSize: '1.5rem',
                            color: 'white',
                          }}
                        />
                      )}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>{!loader && <NoDataFound />}</>
        )}
      </div>
      {lockBatchResp.code === 200 ? (
        <Modal show={lockModalShow} onHide={handleLockClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>Batch Locked successfully</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : lockBatchResp.code === 400 ? (
        <Modal show={lockModalShow} onHide={handleLockClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Failed</Modal.Title>
          </Modal.Header>
          <Modal.Body>{lockBatchResp.data.message}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : (
        <Modal show={lockModalShow} onHide={handleLockClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure, you want to lock the Batch?</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleLockClose}>
              Cancel
            </Button>
            <Button variant='primary' htmlType='submit' onClick={lockBatch}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {delBatchResp.code === 200 ? (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>Batch Deleted successfully</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : delBatchResp.code === 400 ? (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className='text-center'>Failed</Modal.Title>
          </Modal.Header>
          <Modal.Body>{delBatchResp.data.message}</Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      ) : (
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure, you want to delete the Batch?</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant='primary'
              htmlType='submit'
              onClick={() => {
                deleteBatch(tableValues.batchId);
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Modal show={detailModalShow} onHide={handleLockClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Batch-{inventoryListingResp[0]?.batchId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table id='customers'>
            <thead class=''>
              <tr>
                {/* <th>Batch No.</th> */}
                <th>Product Name</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {inventoryListingResp
                ? inventoryListingResp.map((tableValues) => (
                    <tr>
                      {/* <td  style={{ width: '200px' }} ><a >{tableValues.batchId ? tableValues.batchId : 'null'}</a></td> */}
                      <td style={{ width: '200px' }}>{tableValues.productName ? tableValues.productName : 'null'}</td>
                      <td style={{ width: '150px', textAlign: 'center' }}>{tableValues.prodQty ? tableValues.prodQty : 'null'}</td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <div className='row'>{currentPage && pagesCount ? <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={currentPage} total={pagesCount} showTotal={(total) => `Total ${total} items`} showSizeChanger /> : ' '}</div>
    </div>
  );
};

export default InventoryListing2;
